import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Parent route for the OAuth-flow SPA pages (currently just /oauth/authorize, the
 * consent page rendered to authenticated users via the Client Metadata Document
 * flow). Acts as a passthrough — every visual chrome decision belongs to the
 * child consent route itself.
 *
 * IMPORTANT: only SPA-served OAuth paths live under here. /oauth/token, /oauth/consent,
 * /oauth/revoke, /oauth/client-info and /oauth/client-logo are Fastify backend routes
 * — the Cloudflare Worker forwards everything under /oauth EXCEPT /oauth/authorize to
 * the backend (see workers/curium-static/src/index.ts SPA_OVERRIDE_EXACT).
 */
export const Route = createFileRoute('/oauth')({
    component: OAuthLayout,
});

function OAuthLayout() {
    return <Outlet />;
}
